export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '100 Attività Pronte all’Uso per Metodologia della Ricerca',
    value: '19 €',
    desc: '100 attività tra esercizi, casi, sfide e applicazioni pratiche da utilizzare direttamente con gli studenti. Problemi di ricerca, ipotesi, variabili, campionamento, strumenti, analisi, fonti, scrittura e molto altro.',
    benefit:
      'Materiale già pensato per l’aula: meno tempo a inventare esercizi e più tempo per insegnare.',
  },
  {
    id: '02',
    title: 'Banca di Casi e Progetti di Ricerca',
    value: '17 €',
    desc: '50 casi e progetti multidisciplinari che mostrano agli studenti come collegare Problema → Domanda → Obiettivi → Metodo → Campione → Analisi → Risultati → Conclusione.',
    benefit: 'Non limitarti a spiegare la ricerca. Mostra come si costruisce.',
  },
  {
    id: '03',
    title: 'Kit di Valutazione della Ricerca',
    value: '15 €',
    desc: 'Rubriche, checklist, criteri di valutazione e feedback pronti all’uso per valutare tutte le fasi del processo di ricerca.',
    benefit:
      'Non creare ogni rubrica da zero. Valuta con criteri più chiari e coerenti.',
  },
  {
    id: '04',
    title: '30 Lezioni di Emergenza di Metodologia della Ricerca',
    value: '14 €',
    desc: '30 lezioni complete e indipendenti da utilizzare quando hai poco tempo, devi sostituire una lezione o vuoi rinforzare un argomento. Ogni lezione include spiegazione, esempio, attività, domande e guida di correzione.',
    benefit: 'Apri, scegli e porta la lezione direttamente in aula.',
  },
  {
    id: '05',
    title: 'Laboratorio degli Errori Metodologici',
    value: '18 €',
    desc: '100 errori realistici da individuare, analizzare, correggere e difendere. Gli studenti imparano non soltanto cosa è corretto, ma anche perché una ricerca può non reggere metodologicamente.',
    benefit: 'Trasforma gli errori in esercizi di pensiero critico.',
  },
]

export const BONUS_TOTAL_VALUE = '83 €'
